var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SiruiSearch',{ref:"formItem",attrs:{"query":_vm.baseFormData,"columns":_vm.formColumn,"isQueryPanel":false,"rules":_vm.formRules},on:{"changeMethod":_vm.changeMethod}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }